import styled from 'styled-components'
import { Colors, Spacing } from 'styles'

export const Container = styled.div`
  width: 100%;
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const LoadingText = styled.p`
  font-size: 1.2rem;
  font-family: SpaceGrotesk;
  font-weight: 600;
`

export const Title = styled.p`
  font-size: 1.4rem;
  font-family: SpaceGrotesk;
  font-weight: 600;
`

export const Info = styled.p`
  font-size: 1rem;
  font-family: Inter;
  font-weight: 400;
`

export const WarningContainer = styled.div`
  width: 100%;
  background-color: ${Colors.SUPPORT_ALERT};
  padding: 10px 20px;
  border-radius: ${Spacing.SCALE_16}px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 10px;
`

export const WarningText = styled.p`
  font-weight: 300;
  font-size: 1rem;
  color: ${Colors.BLACK};
  font-family: Inter;
  margin: 0;
`
